import moment from 'moment'
import { PropOptionSelect } from '@/models'

const yearStartToCreateRange = 2021

const today = (format = 'YYYY-MM-DD'): string => {
    const today_date = new Date()
    return moment(today_date).format(format)
}

const currentMonth = () => {
    const today_date = new Date()
    return moment(today_date).month() + 1
}

const currentYear = () => {
    const today_date = new Date()
    return moment(today_date).year()
}

const setWithCurrentYear = (date: string) => {
    return moment(date).year(currentYear()).format('YYYY-MM-DD')
}

const formatDateOfApi = (value: string) => {
    return moment(value).format('DD/MM/YYYY')
}

const getDateArray = (date: string): string[] => {
    return date.split('-')
}

const formatDate = (value: string) => {
    let date = new Date()
    const arrayValue = value.split('-')
    if (arrayValue.length === 3) {
        date.setDate(Number(arrayValue[2]))
        const month = Number(arrayValue[1])
        date.setMonth(month > 0 ? month - 1 : month)
        date.setFullYear(Number(arrayValue[0]))
    } else {
        date = new Date(value)
    }
    return moment(date).format('DD/MM/YYYY')
}

const getOnlyHourAndMinute = (time: string) => {
    if (time && time.indexOf(':') > -1) {
        const timeArray = time.trim().split(':')
        if (timeArray.length > 1) {
            return `${timeArray[0]}:${timeArray[1]}`
        }
    }
    return time
}

const createRangeYears = (yearStart: number = yearStartToCreateRange, yearsEnd: number = new Date().getFullYear()): PropOptionSelect[] => {
    if (yearStart > yearsEnd) {
        return []
    }
    const years: PropOptionSelect[] = []
    for (let i = yearStart; i <= yearsEnd + 1; i++) {
        years.push({
            text: String(i),
            value: i
        })
    }
    return years
}

const getAllMonths = (): PropOptionSelect[] => {
    return [
        {
            text: 'Enero',
            value: 1
        },
        {
            text: 'Febrero',
            value: 2
        },
        {
            text: 'Marzo',
            value: 3
        },
        {
            text: 'Abril',
            value: 4
        },
        {
            text: 'Mayo',
            value: 5
        },
        {
            text: 'Junio',
            value: 6
        },
        {
            text: 'Julio',
            value: 7
        },
        {
            text: 'Agosto',
            value: 8
        },
        {
            text: 'Septiembre',
            value: 9
        },
        {
            text: 'Octubre',
            value: 10
        },
        {
            text: 'Noviembre',
            value: 11
        },
        {
            text: 'Diciembre',
            value: 12
        }
    ]
}

const getMonthName = (month: number): string => {
    const months = getAllMonths()
    const monthName = months.find(m => m.value === month)
    return monthName ? monthName.text : ''
}

const fortnightsDefault: PropOptionSelect[] = [
    {
        value: 1,
        text: 'Primera Quincena'
    },
    {
        value: 2,
        text: 'Segunda Quincena'
    }
]

const fortnightsDefault2: PropOptionSelect[] = [
    {
        value: 1,
        text: 'Primera Quincena'
    },
    {
        value: 2,
        text: 'Segunda Quincena'
    },
    {
        value: 3,
        text: 'Boleta Mensual'
    }
]

const getFortnightText = (fortnight: number): string => {
    const fortnights = fortnightsDefault
    const fortnightName = fortnights.find(f => f.value === fortnight)
    return fortnightName ? fortnightName.text : ''
}

const addDaysToDate = (date: string, days: number) => {
    if (date) {
        const d = moment(date)
        const dayAdded = d.add(days, 'days')
        return dayAdded.format('YYYY-MM-DD')
    }
    return date
}

const isSunday = (date: string) => {
    const d = moment(date).day()
    if (d === 0) {
        return true
    }
    return false
}

const isHoliday = (date: string) => {
        return false
}

export {
    today,
    formatDate,
    getOnlyHourAndMinute,
    createRangeYears,
    getAllMonths,
    fortnightsDefault,
    fortnightsDefault2,
    formatDateOfApi,
    getDateArray,
    currentMonth,
    currentYear,
    setWithCurrentYear,
    getFortnightText,
    getMonthName,
    addDaysToDate,
    isSunday,
    isHoliday
}
